<template>
<div>
  <div class="other-tab">
    <div class="left-info">
      <i class="empty" :class="{ select: selectFlag }" @click="checkSelect"></i>
      <p>
        我已阅读并同意<span @click="openPopup('1')">
          <template v-if="showBoXueGu">
          《博学谷用户服务协议》
        </template>
        <template v-else>
          《用户服务协议》
        </template>
          </span
        >和<span @click="openPopup('2')">《隐私政策》</span>
      </p>
      <!-- <div class="tips" v-show="qrshow || subshow">请阅读并勾选协议</div> -->
    </div>
  </div>
   
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      phoneHas: false, // 手机号是否已经注册
      popupType: "", // 协议弹框类型  1、博学谷用户服务协议  2、隐私政策
      showBoXueGu:true,
    };
  },
  props: ["type", "qrshow", "selectFlag", "subshow"],
 
  mounted(){
    if(window.location.search.indexOf('match')>-1){
      this.showBoXueGu=false
    }
  },
  methods: {
    ...mapMutations(["protocolDialogshow", "protocolDialogHidden","isProtocolLoginYes"]),
    // 协议提示关闭
   handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    openPopup(type) {
      if (type == 1) {
        window.open("https://file.boxuegu.com/app/agreement/bxg_service.html");
      } else {
        window.open("https://file.boxuegu.com/app/agreement/bxg_policy.html");
      }
    },
    // 关闭用户协议、隐私政策弹框
    closePopup() {
      this.isShow = false;
    },
    // 校验验证码更改时，移除错误校验提示
    codeChange() {
      this.codeErr = false;
    },
    // 博学谷用户服务协议、隐私政策是否同意
    checkSelect() {
     
      this.$emit("checkSelect");
    },
  },
};
</script>

<style lang="scss" scoped>
.other-tab {
  margin-top: 8px;
  height: 22px;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  p {
    display: inline-block;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: rgba(134, 144, 156, 1) !important;
    white-space: nowrap;
    span {
      cursor: pointer;
      color: rgba(22, 93, 255, 1);
      &:hover {
        color: #4080ff;
      }
    }
  }
  .left-info {
    display: flex;
    align-items: center;
    position: relative;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      vertical-align: middle;
      position: relative;
      cursor: pointer;
    }
    .empty {
      background: url("../../assets/register/icon-bxg-empty.png") no-repeat;
      background-size: 100% 100%;
    }
    .select {
      background: url("../../assets/register/icon-bxg-select.png") no-repeat;
      background-size: 100% 100%;
    }
    .tips {
      top: -40px;
      left: -48px;
      position: absolute;
      width: 112px;
      height: 34px;
      background: #165dff;
      box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05),
        0px 8px 10px 1px rgba(0, 0, 0, 0.06),
        0px 5px 5px -3px rgba(0, 0, 0, 0.1);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      text-align: center;
      border-radius: 4px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        right: 0px;
        left: 0;
        bottom: -4px;

        margin: auto;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        width: 8px;
        height: 8px;
        background: #165dff;
      }
    }
  }
}
</style>
